import { proxy } from 'valtio';

export type ImageUploadStatus = 'uploading' | 'failed';

export type State = {
  statusByBlockId: Record<string, ImageUploadStatus>;
};

const initialState: State = {
  statusByBlockId: {},
};

export const imageUploadState = proxy<State>(initialState);

export const imageUploadActions = {
  start(blockId: string): void {
    imageUploadState.statusByBlockId[blockId] = 'uploading';
  },
  fail(blockId: string): void {
    imageUploadState.statusByBlockId[blockId] = 'failed';
  },
  clear(blockId: string): void {
    delete imageUploadState.statusByBlockId[blockId];
  },
  reset(): void {
    imageUploadState.statusByBlockId = {};
  },
};
